export default "__VITE_ASSET__DjiLHkIm__"